export default `float s,e;
  vec3 q=p*2.;
  s=3.;
  for(int j=0;j++<8;s*=e)
    p=sign(p)*(1.-abs(abs(p-2.)-1.)),
    p=p*(e=6./min(dot(p,p)+.3,3.))+q-vec3(3.0,1.0,12.0);
  return length(p)/s;
}`